import React, { FC } from "react";
import { UIBrandedFareInfo, UIFlightSegment } from "@flights/types";
import Frame from "components/elements/Frame";
import { CardBaggagesWithIcon } from "@flights/search-ui";
import { useFlightCardLuggageWithCheckmarksController } from "./useFlightCardLuggageWithCheckmarksController";
import { Stack, Text } from "@bookingcom/bui-react";
import { lowerCase, startCase } from "lodash";

export const FlightCardLuggageWithCheckmarks: FC<{
  segments: UIFlightSegment[];
  showFareName: boolean;
  brandedFareInfo?: UIBrandedFareInfo;
}> = ({ segments, showFareName, brandedFareInfo }) => {
  const { cabinBagText, personalBagText, checkedBagText, titleText } =
    useFlightCardLuggageWithCheckmarksController(segments);

  if (!cabinBagText && !personalBagText && !checkedBagText) {
    return null;
  }

  return (
    <Stack gap={0.5}>
      {showFareName && brandedFareInfo && <BrandedFareDescription {...brandedFareInfo} />}
      <CardBaggagesWithIcon
        align="end"
        personalBagText={personalBagText}
        cabinBagText={cabinBagText}
        checkedBagText={checkedBagText}
        titleText={titleText}
      />
    </Stack>
  );
};

const BrandedFareDescription = (brandedFareInfo?: UIBrandedFareInfo) => {
  if (!brandedFareInfo) {
    return null;
  }

  return (
    <Frame>
      <Text variant="small_1" align="end" color="neutral">
        {startCase(lowerCase(brandedFareInfo.fareName))}
      </Text>
    </Frame>
  );
};

export default FlightCardLuggageWithCheckmarks;
